// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ManagerRole .table-wrap[data-v-0c39cbbc] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
